import PlayerBets from './PlayerBets';

export default PlayerBets;
